// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"228":"a663d9aa","729":"0d3179f2"}[chunkId] + ".css";
};